<template>
  <div class="page">
    <div class="searchBox">
      <el-form>
        <el-row>
          <el-col :span="4">
            <el-form-item>
              <el-input
                style="width: 200px; margin-right: 10px"
                placeholder="请输入关键字"
                v-model="form.keyword"
                @keyup.enter.native="changeSearch"
                size="small"
              ></el-input>
              <el-button
                @click="changeSearch"
                icon="el-icon-search"
                type="warning"
                size="small"
                >搜索</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="过期时间" :label-width="'70px'">
              <el-select
                clearable
                style="width: 120px"
                v-model="form.month"
                placeholder="请选择"
                @change="changeSearch"
                size="small"
              >
                <el-option
                  v-for="item in [
                    { label: '全部', value: '0' },
                    { label: '最近2个月', value: '2' },
                    { label: '最近4个月', value: '4' },
                    { label: '最近6个月', value: '6' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="分类" :label-width="'70px'">
              <el-select
                clearable
                style="width: 120px"
                v-model="form.goodsType"
                placeholder="请选择"
                @change="changeSearch"
                size="small"
              >
                <el-option
                  v-for="item in [
                    { label: '商品', value: '0' },
                    { label: '药品', value: '1' },
                    { label: '耗材', value: '7' },
                  ]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="门店" :label-width="'70px'">
              <el-select
                clearable
                style="width: 120px"
                v-model="form.shopId"
                placeholder="请选择"
                @change="changeSearch"
                size="small"
              >
                <el-option
                  v-for="item in shopList"
                  :key="item.shop_id"
                  :label="item.shop_name"
                  :value="item.shop_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <resetBtn @reset="reset" style="width: 60px"></resetBtn>
          </el-col>
          <el-col :span="4">
            <el-button
              size="small"
              :disabled="exportDisabled"
              type="warning"
              @click="expireWarning('0')"
              v-if="$buttonAuthority('cangku-guoqi-educe')"
              >导出汇总</el-button
            >
            <el-button
              size="small"
              :disabled="exportDetailDisabled"
              type="warning"
              @click="expireWarning('1')"
              v-if="$buttonAuthority('cangku-guoqi-educe')"
              >导出明细</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="pageConBox">
      <el-table class="table" :data="tableData" style="width: 100%">
        <el-table-column prop="productName" label="名称"> </el-table-column>
        <el-table-column prop="categoryName" label="类别"> </el-table-column>
        <el-table-column label="分类">
          <template slot-scope="scope">
            {{
              scope.row.goodsType == null
                ? ""
                : getgoodName(scope.row.goodsType)
            }}
          </template>
        </el-table-column>
        <el-table-column label="规格">
          <template slot-scope="scope">
            {{ scope.row.skuName == null ? "" : scope.row.skuName }}
          </template>
        </el-table-column>
        <el-table-column prop="count" label="数量"> </el-table-column>
        <!-- <el-table-column label="有效期至" width="160">
          <template slot-scope="scope">
            {{ $public.FTime(scope.row.validityStopDate) }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="剩余天数">
          <template v-if="scope.row.validityStopDate" slot-scope="scope">
            {{ $public.FAge(new Date(), scope.row.validityStopDate)[0] }}年
            {{ $public.FAge(new Date(), scope.row.validityStopDate)[1] }}月
            {{ $public.FAge(new Date(), scope.row.validityStopDate)[2] }}日
            {{ $public.FAge(new Date(), scope.row.validityStopDate)[3] }}时
            {{ $public.FAge(new Date(), scope.row.validityStopDate)[4] }}分
            {{ $public.FAge(new Date(), scope.row.validityStopDate)[5] }}秒
          </template>
        </el-table-column> -->
      </el-table>
      <page
        :page="page.page"
        :total="page.total"
        @change="pageChange"
        style="padding: 12px 0"
      ></page>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import shopList from "../../../util/shopList";
import page from "../../../components/page.vue";
import resetBtn from "../../../components/resetBtn.vue";
export default {
  components: { page, resetBtn },
  data() {
    return {
      exportDisabled: false,
      exportDetailDisabled: false,
      shopList: shopList,
      form: {
        keyword: "",
        month: "0",
        goodsType: "0",
        shopId: "",
      },
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
    };
  },
  // beforeRouteEnter(to,from,next){
  // 	next(vm=>{
  // 		vm.page.page=1;
  // 		this.getTableData();
  // 	})
  // },
  mounted() {
    this.getTableData();
  },
  methods: {
    getgoodName(type) {
      if (type == 0) {
        return "商品";
      } else if (type == 1) {
        return "药品";
      } else if (type == 7) {
        return "耗材";
      }
    },
    // 导出明细/汇总
    expireWarning(type) {
      if (!this.tableData.length) {
        this.$message({
          message: "暂无列表数据",
          type: "error",
        });
        return;
      }
      let params = {
        keywords: this.form.keyword,
        shopId: this.form.shopId,
        month: this.form.month,
        goodsType: this.form.goodsType,
      };
      let loading = this.$loading();
      if (type == "0") {
        console.log("导出");
        this.exportDisabled = true;
        axios
          .get(process.env.VUE_APP_Url3 + "api/export/product/expire/warning", {
            params,
            responseType: "blob",
          })
          .then((response) => {
            loading.close();
            // console.log(response.data, "地址---");
            var href = window.URL.createObjectURL(response.data); //创建下载的链接
            var downloadElement = document.createElement("a");
            downloadElement.href = href;
            downloadElement.download = "列表导出.xlsx";
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.exportDisabled = false;
          });
      } else {
        this.exportDetailDisabled = true;
        // console.log("导出明细");
        axios
          .get(
            process.env.VUE_APP_Url3 +
              "api/export/product/expire/warning/detail",
            {
              params,
              responseType: "blob",
            }
          )
          .then((response) => {
            loading.close();
            // console.log(response.data, "地址---");
            var href = window.URL.createObjectURL(response.data); //创建下载的链接
            var downloadElement = document.createElement("a");
            downloadElement.href = href;
            downloadElement.download = "明细列表导出.xlsx";
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            this.exportDetailDisabled = false;
          });
      }
      this.reset();
    },
    // 重置筛选
    reset() {
      this.page.page = 1;
      this.form.keyword = "";
      this.form.month = "0";
      this.form.shopId = "";
      this.form.goodsType = "0";
      this.getTableData();
    },
    // 点击查询
    changeSearch() {
      this.page.page = 1;
      this.getTableData();
    },
    // 页码改变
    pageChange(a) {
      this.page.page = a;
      this.getTableData();
    },
    // 获取表格数据
    getTableData() {
      let params = {
        keywords: this.form.keyword,
        shopId: this.form.shopId,
        month: this.form.month,
        goodsType: this.form.goodsType,
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
      };
      let loading = this.$loading();
      this.$http
        .post(process.env.VUE_APP_Url3 + "api/product/expire/warning", params)
        .then((res) => {
          loading.close();
          console.log(res.data.data, "数据-----");
          if (res.code == 0) {
            this.tableData = res.data.data;
            this.page.total = res.data.count;
          }
        });
    },
    // 递归
    recursion(arr) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].children == null || arr[i].children.length == 0) {
          arr[i].children = null;
        } else {
          this.recursion(arr[i].children);
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  .searchBox {
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .pageConBox {
    min-height: 600px;
    margin-top: 12px;
  }
}
</style>
